<template>
  <div v-if="useDesignV2" class="kn-login" v-loading="loadingLogin">
    <section class="kn-login__hero" aria-hidden="true">
      <div class="kn-login__hero-inner">
        <div class="kn-login__hero-title">Цели, KPI и оценка —<br/>в одном месте</div>
        <div class="kn-login__hero-text">Ставьте цели, каскадируйте их по команде и отслеживайте прогресс без таблиц и рассылок.</div>

        <div class="kn-login__visual">
          <div class="kn-login__kpi kn-login__kpi--1">
            <div class="kn-login__kpi-head">
              <span class="kn-login__kpi-icon"><i class="fas fa-bullseye"></i></span>
              <span>Квартальная цель</span>
            </div>
            <div class="kn-login__kpi-value">85%</div>
            <div class="kn-login__kpi-bar"><span style="width: 85%"></span></div>
          </div>

          <div class="kn-login__kpi kn-login__kpi--2">
            <div class="kn-login__kpi-head">
              <span class="kn-login__kpi-icon"><i class="fas fa-star"></i></span>
              <span>Проектный прогресс</span>
            </div>
            <div class="kn-login__kpi-value">72%</div>
            <div class="kn-login__kpi-bar"><span style="width: 72%"></span></div>
          </div>

          <div class="kn-login__kpi kn-login__kpi--3">
            <div class="kn-login__kpi-head">
              <span class="kn-login__kpi-icon"><i class="fas fa-chart-bar"></i></span>
              <span>KPI за период</span>
            </div>
            <div class="kn-login__kpi-value">94%</div>
            <div class="kn-login__kpi-bar"><span style="width: 94%"></span></div>
          </div>

          <div class="kn-login__ring">
            <svg viewBox="0 0 120 120">
              <circle cx="60" cy="60" r="50" class="kn-login__ring-track"/>
              <circle cx="60" cy="60" r="50" class="kn-login__ring-value" :stroke-dasharray="ringDash"/>
            </svg>
            <div class="kn-login__ring-label">
              <div class="kn-login__ring-number">78%</div>
              <div class="kn-login__ring-caption">Выполнение плана</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="kn-login__form-side">
      <div class="kn-login__card">
        <div class="kn-login__logo"><img alt="Knomary" src="@/assets/img/logo.png"/></div>
        <h1 class="kn-login__title">Авторизация</h1>
        <div class="kn-login__subtitle">Войдите в аккаунт, чтобы продолжить работу с целями</div>

        <template v-for="(authMethodName, index) in authMethods">
          <div v-if="index > 0" :key="authMethodName + '-divider'" class="kn-login__divider"><span>или</span></div>
          <auth-method
            :key="authMethodName"
            :method-name="authMethodName"
          ></auth-method>
        </template>
      </div>
    </section>
  </div>

  <div v-else class="login" v-loading="loadingLogin">
    <el-card style="padding: 24px">
      <h2>Авторизация</h2>

      <auth-method
        v-for="authMethodName in authMethods"
        :key="authMethodName"
        :method-name="authMethodName"
      ></auth-method>

    </el-card>
  </div>
</template>

<script>


import AuthMethod from "@/auth/AuthMethod.vue";
import {mapGetters} from "vuex";

export default {
  name: 'Login',
  components: {AuthMethod},

  computed: {
    ...mapGetters(['loadingLogin']),
    ...mapGetters(['user']),
    ...mapGetters('settings', ['useDesignV2']),
    ringDash() {
      const circumference = 2 * Math.PI * 50;
      return `${circumference * 0.78} ${circumference}`;
    },
  },

  watch:{
    'user.id': function(authUserId){
      if( authUserId ){
        window.location.href= '/';
      }
    }
  },

  async mounted() {
      this.authMethods = await this.$companyConfiguration.auth.getEnabledAuthMethods();
  },

  data() {
    return {
      authMethods: [],
    }
  },

  methods: {}
}

</script>

<style lang="scss" scoped>

.login {
  height: 90vh;
  position: relative;
  /*border: 3px solid green;*/
}

.el-card {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}


</style>
<style lang="scss">

.login .el-card {
  //margin-top:300px;
  width: 340px;
  //display: flex;
  justify-content: center;
}

body.designV2 #app > .el-main {
  padding: 0;
}

.kn-login {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  min-height: 100vh;
  background-color: var(--kn-bg);
  text-align: left;

  &__hero {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px;
    background:
      radial-gradient(circle at 15% 20%, rgba(255, 255, 255, 0.35), transparent 40%),
      linear-gradient(140deg, #7C5CFF 0%, #A68CFF 45%, #EDE9FF 100%);
  }

  &__hero-inner {
    position: relative;
    width: 100%;
    max-width: 560px;
  }

  &__hero-title {
    color: #fff;
    font-size: 34px;
    font-weight: 700;
    line-height: 1.15;
    letter-spacing: -0.02em;
  }

  &__hero-text {
    max-width: 420px;
    margin-top: 14px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    line-height: 1.55;
  }

  &__visual {
    position: relative;
    height: 380px;
    margin-top: 40px;
  }

  &__kpi {
    position: absolute;
    width: 230px;
    padding: 16px 18px;
    border-radius: 18px;
    background-color: rgba(255, 255, 255, 0.92);
    box-shadow: 0 18px 40px rgba(60, 30, 160, 0.18);
    backdrop-filter: blur(6px);
    animation: kn-float 6s ease-in-out infinite;

    &--1 { top: 0; left: 10%; }
    &--2 { top: 130px; left: 0; animation-delay: -2s; }
    &--3 { top: 260px; left: 16%; animation-delay: -4s; }
  }

  &__kpi-head {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #1A1A2E;
    font-size: 13px;
    font-weight: 600;
  }

  &__kpi-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 10px;
    background-color: #EDE9FF;
    color: #7C5CFF;
  }

  &__kpi-value {
    margin: 8px 0 8px;
    color: #1A1A2E;
    font-size: 24px;
    font-weight: 700;
  }

  &__kpi-bar {
    height: 6px;
    border-radius: 999px;
    background-color: #EDE9FF;
    overflow: hidden;

    span {
      display: block;
      height: 100%;
      border-radius: inherit;
      background-color: #7C5CFF;
    }
  }

  &__ring {
    position: absolute;
    top: 80px;
    right: 0;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.92);
    box-shadow: 0 18px 40px rgba(60, 30, 160, 0.18);

    svg {
      width: 100%;
      height: 100%;
      transform: rotate(-90deg);
    }
  }

  &__ring-track {
    fill: none;
    stroke: #EDE9FF;
    stroke-width: 10;
  }

  &__ring-value {
    fill: none;
    stroke: #7C5CFF;
    stroke-width: 10;
    stroke-linecap: round;
  }

  &__ring-label {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__ring-number {
    color: #1A1A2E;
    font-size: 30px;
    font-weight: 700;
  }

  &__ring-caption {
    color: #6B7280;
    font-size: 12px;
  }

  &__form-side {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 24px;
  }

  &__card {
    width: 100%;
    max-width: 420px;
    padding: 40px;
    border: 1px solid var(--kn-border);
    border-radius: var(--kn-radius-lg);
    background-color: var(--kn-card);
    box-shadow: var(--kn-shadow-card);
    box-sizing: border-box;

    .auth-method-component {
      margin-bottom: 0;

      .el-button {
        width: 100%;
        height: 44px;
        font-size: 14px;
      }
    }
  }

  &__logo img {
    display: block;
    height: 24px;
    width: auto;
  }

  &__title {
    margin: 28px 0 6px;
    font-size: 28px !important;
    letter-spacing: -0.02em;
  }

  &__subtitle {
    margin-bottom: 28px;
    color: var(--kn-text-muted);
    font-size: 14px;
  }

  &__divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 20px 0;
    color: var(--kn-text-faint);
    font-size: 13px;

    &::before, &::after {
      content: "";
      flex: 1;
      height: 1px;
      background-color: var(--kn-border);
    }
  }
}

@keyframes kn-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

@media (prefers-reduced-motion: reduce) {
  .kn-login__kpi { animation: none; }
}

@media (max-width: 1023px) {
  .kn-login {
    grid-template-columns: 1fr;

    &__hero { display: none; }
  }
}

@media (max-width: 480px) {
  .kn-login__card {
    padding: 28px 20px;
    border: 0;
    box-shadow: none;
    background-color: transparent;
  }
}
</style>
